import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import React from "react";

export const sitemapSection = {
  group: "group",
  subGroup: "subGroup",
  link: "link",
};

export const adminConsoleSection = {
  section: "section",
  page: "page",
};

export const homePageCategorySection = {
  category: "category",
  link: "link",
};
export const homePageCategoryIcons = {
  reportsLogo: "reportsLogo",
  libraryServicesLogo: "libraryServicesLogo",
  apostilleLogo: "apostilleLogo",
  certificatesLogo: "certificatesLogo",
  academicRecognitionLogo: "academicRecognitionLogo",
  registersLogo: "registersLogo",
  commonServicesLogo: "commonServicesLogo",
  impactFactorLogo: "impactFactorLogo",
  profQualificationLogo: "profQualificationLogo",
};

export const YesMessage = () => {
  const { t } = useTranslation();
  return <Box style={{ color: "green" }}>{t("m.yes")}</Box>;
};

export const NoMessage = () => {
  const { t } = useTranslation();
  return <Box style={{ color: "red" }}>{t("m.no")}</Box>;
};
